import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from './store';
import { getListWorkSpace } from '../api/platform';

export interface ITeamSetting {
  status?: number;
  manager_level_access?: number;
  training_disclosure?: {
    status?: number;
  };
  course_results?: {
    status?: number;
  };
  email_behaviour_report?: {
    status?: number;
  };
  phishfit_score?: {
    status?: number;
    allow_manager_access?: number;
  };
}

export interface IWorkSpaceData {
  cell_id: number | undefined;
  student_id: number | undefined;
  first_name: string;
  last_name: string;
  cell_name: string;
  tz_name: string;
  email: string;
  is_manager: boolean;
  has_course_policy_module: number|undefined;
  enable_profile: boolean;
  enable_my_dashboard: boolean;
  show_training_data: boolean,
  show_phishing_data: boolean,
  enable_leaderboard: boolean,
  show_email_reporting_data: boolean,
  show_training_completion_data: boolean,
  show_achievement_collection_data: boolean,
  show_attribute_email_reporting?: boolean,
  show_attribute_training_completion?: boolean,
  show_attribute_achievement_completion?: boolean,
  team_setting?: ITeamSetting,
  manager_level?: number | null
}
export interface WorkSpaceEventsObjectState {
  workSpaceData: IWorkSpaceData[];
  isLoading: boolean;
  error?: string;
  workSpaceCurrentData?: IWorkSpaceData;
}

const initialState: WorkSpaceEventsObjectState = {
  workSpaceData: [],
  workSpaceCurrentData: undefined,
  isLoading: false,
  error: undefined
};

export const workSpaceEvents = createAsyncThunk(
  'workSpaceEventPlatform',
  async () => {
    const response = await getListWorkSpace();
    const data = response.data as IWorkSpaceData[];
    return data && data.length > 0
      ? data.map((item) => {
          return {
            cell_id: item.cell_id ?? undefined,
            student_id: item.student_id ?? undefined,
            first_name: item.first_name ?? '',
            last_name: item.last_name ?? '',
            cell_name: item.cell_name ?? '',
            tz_name: item.tz_name ?? '',
            email: item.email ?? '',
            is_manager: item.is_manager ?? false,
            has_course_policy_module: item.has_course_policy_module ?? 0,
            enable_profile: Boolean(item.enable_profile),
            enable_my_dashboard: Boolean(item.enable_my_dashboard),
            show_training_data: Boolean(item.show_training_data),
            show_phishing_data: Boolean(item.show_phishing_data),
            enable_leaderboard: Boolean(item.enable_leaderboard),
            show_email_reporting_data: Boolean(item.show_email_reporting_data),
            show_training_completion_data: Boolean(item.show_training_completion_data),
            show_achievement_collection_data: Boolean(item.show_achievement_collection_data),
            show_attribute_email_reporting: Boolean(item?.show_attribute_email_reporting),
            show_attribute_training_completion: Boolean(item?.show_attribute_training_completion),
            show_attribute_achievement_completion: Boolean(item?.show_attribute_achievement_completion),
            team_setting: item.team_setting ?? undefined,
            manager_level: item.manager_level ?? null
          };
        })
      : [];
    }
);

export const workSpaceSlice = createSlice({
  name: 'loginEvents',
  initialState,
  reducers: {
    setWorkSpaceEventData: (state, action: PayloadAction<IWorkSpaceData>) => {
      state.isLoading = false;
      state.workSpaceCurrentData = action.payload;
      state.error = undefined;
    },
    removeWorkSpace: (state) => {
      state.isLoading = false;
      state.workSpaceData = [];
      state.error = undefined;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(workSpaceEvents.pending, (state) => {
      state.isLoading = true;
    });

    builder.addCase(workSpaceEvents.fulfilled, (state, action: PayloadAction<IWorkSpaceData[]>) => {
      state.isLoading = false;
      state.workSpaceData = action.payload;
      state.error = undefined;
    });

    builder.addCase(workSpaceEvents.rejected, (state, action) => {
      state.isLoading = false;
      state.workSpaceData = [];
      state.error = action.payload as string;
    });
  }
});

export const { setWorkSpaceEventData, removeWorkSpace } = workSpaceSlice.actions;

export const workSpaceEventsDataSelector = (state: RootState) => state.workSpaceEvents;

const workSpaceEventsReducer = workSpaceSlice.reducer;
export default workSpaceEventsReducer;
